import {createContext} from 'react';

export interface ScreenSize {
  width: number;
  height: number;
  isMobile: boolean;
}

const ScreenSizeContext = createContext<ScreenSize | undefined>(undefined);

export default ScreenSizeContext;
